import { useState } from 'react';
import { NodePalette } from '../../flow/NodePalette';
import type { NodeKind } from '../../flow/types';
import type { FlowDisplayLanguage } from '../../flow/displayLanguage';

type MazeCardPaletteProps = {
  onTapAdd: (kind: NodeKind) => void;
  allowedNodeKinds?: readonly NodeKind[];
  displayLanguage?: FlowDisplayLanguage;
  showCardNames?: boolean;
  onToggleCardNames?: () => void;
};

export function MazeCardPalette({
  onTapAdd,
  allowedNodeKinds,
  displayLanguage = 'ja',
  showCardNames: controlledShowCardNames,
  onToggleCardNames,
}: MazeCardPaletteProps) {
  const [internalShowCardNames, setInternalShowCardNames] = useState(true);
  const showCardNames = controlledShowCardNames ?? internalShowCardNames;
  const toggleCardNames = onToggleCardNames
    ?? (() => setInternalShowCardNames((current) => !current));

  return (
    <NodePalette
      className="maze-card-palette h-full w-full"
      layout="dock"
      includeMazeOnly
      onTapAdd={onTapAdd}
      allowedNodeKinds={allowedNodeKinds}
      displayLanguage={displayLanguage}
      showCardNames={showCardNames}
      onToggleCardNames={toggleCardNames}
    />
  );
}
